/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState,useEffect,useRef  } from "react";
import ReactDOM from "react-dom";
import axios from 'axios';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
// reactstrap components
import { Container, Row, Col } from "reactstrap";
import { Table } from 'reactstrap';
import { Button } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Form, FormGroup } from 'reactstrap';
import { connect } from 'react-redux';
import {setProducts} from '../../actions/quote'
import Category from "../Category.js"
import {supplier_arry} from "../../config"
import { API_URL, downloadFile } from"../../network"
import Moment from 'react-moment';

// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import CardsFooter from "components/Footers/CardsFooter.js";
import {
  SortableContainer,
  SortableElement,
  arrayMove
} from "react-sortable-hoc";

import "react-virtualized/styles.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";
// index page sections
// import Hero from "./IndexSections/Hero.js";
// import Buttons from "./IndexSections/Buttons.js";
// import Inputs from "./IndexSections/Inputs.js";
// import CustomControls from "./IndexSections/CustomControls.js";
// import Menus from "./IndexSections/Menus.js";
// import Navbars from "./IndexSections/Navbars.js";
// import Tabs from "./IndexSections/Tabs.js";
// import Progress from "./IndexSections/Progress.js";
// import Pagination from "./IndexSections/Pagination.js";
// import Pills from "./IndexSections/Pills.js";
// import Labels from "./IndexSections/Labels.js";
// import Alerts from "./IndexSections/Alerts.js";
// import Typography from "./IndexSections/Typography.js";
// import Datepicker from "./IndexSections/Datepicker.js";
// import TooltipPopover from "./IndexSections/TooltipPopover.js";
// import Carousel from "./IndexSections/Carousel.js";
// import Icons from "./IndexSections/Icons.js";
// import Login from "./IndexSections/Login.js";
// import Download from "./IndexSections/Download.js";
import { Tooltip } from 'reactstrap';
import classnames from 'classnames';
import LoadingOverlay from 'react-loading-overlay';
import ScaleLoader from 'react-spinners/ScaleLoader'
import { toast } from 'react-toastify';
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.css';
import InnerImageZoom from 'react-inner-image-zoom';
import { Link } from "react-router-dom";
import DownloadLink from "react-download-link";




function Index(props) {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [uploadingFile, setUploadingFile] = useState(false);
  const [delettingFile, setDeletingFile] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [curSrc, setCurSrc] = useState(null);
  const [tooltipReorder, setTooltipReorder] = useState(false);
  const [tooltipView, setTooltipView] = useState(false);

  const fileRef = useRef(null);

  useEffect(() => {
    getData();
  },[props.selectedUser,props.selectedContact]);


  const toggleTooltipReorder = () => setTooltipReorder(!tooltipReorder);
  const toggletooltipView = () => setTooltipView(!tooltipView);

  const getData = ()=>{
    const token = localStorage.getItem('token_bigbrand');    
    const user = localStorage.getItem('user_bigbrand');
    var role = ""
    if(user && user != undefined){
      var userinfo = JSON.parse(user)
      role = userinfo['role']
    }
    // if(!props.selectedUser && role=="admin"){
    //   setTableData([]); return;
    // }    
    axios.get(`/quotes/orders?userid=${props.selectedUser?props.selectedUser:''}&contactid=${props.selectedContact?props.selectedContact:''}`).then(res => {
      console.log('res.data',res.data)
      if(res.data.status == "success")
        setTableData(res.data.data);
    })    
  }

  const repeatOrder=async(orderId)=>{
    const user = localStorage.getItem('user_bigbrand');
    var role = ""
    if(user && user != undefined){
      var userinfo = JSON.parse(user)
      role = userinfo['role']
    }
    var bodyFormData = new FormData();    
    axios.post(`/quotes/repeat/${orderId}`, bodyFormData).then(res => {
      const result = res.data;
      if(result.status == "success"){        
        toast.success("Your order has been copied");
        if(role=='admin')
          props.history.push("/admin/myorders/edit/"+result.data)
        else
          props.history.push("/myorders/edit/"+result.data)
      }
      else{
        toast.error(result.data);
      }
    }).catch(err => {
      toast.error('Something was wrong. Try again');
    })
  }

  const toggletooltip = () => setTooltipOpen(!tooltipOpen);

  const setLogo = (item)=>{    
    axios.get(`/quotes/logo/${item['id']}`).then(res => {
      if(res.data)
        setCurSrc('data:image/png;base64, '+res.data)
      else
        setCurSrc(null)
    })    
  }

  
  const token = localStorage.getItem('token_bigbrand');    
  const user = localStorage.getItem('user_bigbrand');
  var role = ""
  if(user && user != undefined){
    var userinfo = JSON.parse(user)
    role = userinfo['role']
  }

  var extension = null;
  if(curSrc)
    extension = curSrc.split('.').pop();
  var overlayText = "";
  if(delettingFile)
    overlayText = "Deleting Brand...";
  if(uploadingFile)
    overlayText = "Uploading Brand...";
  return (
    <>    
    <Row className="mt-4">
        <Col md="12">
        </Col>
        <Col md="8">
          <Table className="mt-3" striped >   
            <thead>
              <tr>
                <th></th>
                <th>No.</th>
                <th>Name</th>
                <th>Description</th>
                <th>Status</th>
                <th>Date</th>
                <th>Total</th>
                <th>
                  <div className="text-center">
                    <label className="help-icon d-block m-auto" href="#" id="tooltipReorder" >i</label>
                    <Tooltip placement="bottom" isOpen={tooltipReorder} className="text-left" target="tooltipReorder" toggle={toggleTooltipReorder}>
                      Reorder<br/>
                    </Tooltip>
                    <span>Reorder</span>
                  </div>
                </th>
                <th>
                  <div className="text-center">
                    <label className="help-icon d-block m-auto"  href="#" id="tooltipView" >i</label>
                    <Tooltip placement="bottom" isOpen={tooltipView} className="text-left" target="tooltipView" toggle={toggletooltipView}>
                      View<br/>
                    </Tooltip>
                    <span>View</span>
                  </div>
                </th>
              </tr>
            </thead>               
            <tbody>
              {
                tableData.map((row, index)=>{
                  return (
                    <tr>
                      <td width="50px" className="pl-2 pr-2" scope="row">
                        <span style={{cursor:"pointer"}} onClick={()=>{setLogo(row)}} width="50px" height="50px"> <i className="fa fa-camera" aria-hidden="true"></i></span>
                      </td>
                      <td>
                        Q{row['id']} <b>{row['wfm_id']?`(${row['wfm_id']})`:''}</b>
                      </td>
                      <td>
                      {(row['label']?row['label']:"")+(row['revision']?(" - R"+row['revision']):"")}
                      </td>
                      <td>
                        {row['client_label']}
                      </td>
                      <td>
                        {row['order_status']}
                      </td>
                      <td>
                        {row['created_at']?                  
                          <Moment format="DD/MM/YYYY">
                            {row['created_at']}
                          </Moment>
                          :""
                        }
                      </td>
                      <td>
                      ${row['price']?(row['price']+row['price']/10).toFixed(2):0}
                      </td>
                      <td>                        
                        <Button size="sm"
                          onClick={()=>{repeatOrder(row['id'])}}
                          className="btn-icon btn-3 rounded-0 border-3" color="primary" type="button">
                          <span className="btn-inner--text">Reorder</span>
                        </Button>
                      </td>
                      <td>                        
                        <Button size="sm"
                          onClick={()=>role=='admin'?props.history.push((row.order_status.includes("Completed")?"/admin/myorders/view/":"/admin/myorders/edit/")+row['id']):props.history.push(((row.order_status.includes("Completed")||row.order_status.includes("Requested"))?"/myorders/view/":"/myorders/edit/")+row['id'])}
                          className="btn-icon btn-3 rounded-0 border-3" color="primary" type="button">
                          <span className="btn-inner--text">View</span>
                        </Button>
                      </td>
                    </tr>
                  )
                })
              }
            </tbody>
          </Table>
        </Col>
        <Col md="4">
          <div className="mt-7 resource-preview-container">
            <div className="resource-preview">
              {curSrc && 
                <InnerImageZoom src={curSrc} zoomSrc={curSrc} /> 
              }
            </div>
            {curSrc&&
            <a href={curSrc} download target="_blank" ><i className="fa fa-folder-open"></i></a>
            }
          </div>
        </Col>
      </Row>

        {/* <Modal isOpen={reorderConfirm} toggle={()=>setReorderConfirm(false)} >
            <ModalHeader toggle={()=>setReorderConfirm(false)}>Confirm</ModalHeader>
            <ModalBody>
              Discounts on prior orders are subject to change when re-ordered.
            </ModalBody>
            <ModalFooter>
              <Button color="primary" size="sm" onClick={()=>repeatOrder(props.quote.id)}>OK</Button>{' '}
            </ModalFooter>
          </Modal> */}

      <LoadingOverlay
        active={uploadingFile||delettingFile}
        styles={{
            overlay: (base) => ({
            ...base,
            fontSize:'18px',
            color: 'rgb(5, 37, 51)',
            background: 'rgb(60 60 60 / 48%)',
            position:'fixed',
            zIndex:1000000000
            })
        }}
        spinner = {<ScaleLoader color={'#1976d2'} radius={2.5} margin={2.5} height={40} width={5}/>}
        // spinner
        // text='Loading ...'
        >
      </LoadingOverlay>
       
    </>
  );
}


const mapStateToProps = (state) => {
  return {
    quote: state.quote,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
    setProducts: products=>dispatch(setProducts(products)),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Index);
